import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Field, useFormikContext } from 'formik';
import { debounce } from 'lodash-es';

import { ReactComponent as CrossIcon } from '../../../../../../assets/images/blackCrossIcon.svg';
import CustomMultiAsyncSelect from '../../../../../../components/shared/CustomMultiAsyncSelect/CustomMultiAsyncSelect';
import { loadOptions } from '../../../../../../redux/actions/skillsActions';

import styles from './SkillsSelect.module.scss';

const SkillsSelect = () => {
  const { t } = useTranslation('common');
  const { values, setValues } = useFormikContext();
  const { candidate_skills } = values;

  const skills = useSelector((state) => state.skillsReducer.skills);

  const handleAddSkill = useCallback((option) => {
    setValues((prevValues) => ({ ...prevValues, candidate_skills: option }));
  }, []);

  const handleRemoveSkill = useCallback(
    (option) => {
      const newData = [...candidate_skills];
      const index = candidate_skills.findIndex(({ id }) => id === option.id);
      if (index !== -1) {
        newData.splice(index, 1);
        setValues((prevValues) => ({ ...prevValues, candidate_skills: newData }));
      }
    },
    [values]
  );

  const loadSuggestions = debounce(loadOptions, 1000);

  return (
    <div className={styles.container}>
      <span className={styles.questionHeading}>{t('referral:strengthen.whatGoodAt')}</span>
      <Field
        name="candidate_skills"
        as={CustomMultiAsyncSelect}
        placeholder={t('placeholders.searchSkill')}
        defaultOptions={skills}
        loadOptions={loadSuggestions}
        onChange={(option) => handleAddSkill(option)}
        isSearchable
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option.name}
        backspaceRemovesValue={false}
        closeMenuOnSelect
        hideSelectedOptions
      >
        {!!candidate_skills?.length && (
          <div className={styles.selectedOptionsCont}>
            {candidate_skills.map((option) => (
              <div className={styles.selectedOption} key={option.id}>
                <p className={styles.selectedLabel}>{option.name}</p>
                <CrossIcon className={styles.removeIcon} onClick={() => handleRemoveSkill(option)} />
              </div>
            ))}
          </div>
        )}
      </Field>
    </div>
  );
};

export default SkillsSelect;
